import React from 'react'
import styled from 'styled-components';

const Card = styled.div`
  width: 650px;
  border-radius: 16px;
  padding: 16px 20px;
  justify-content: center;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 12px;
  transition: all 0.4s ease-in-out;
  background: ${({ theme }) => theme.glass};
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid ${({ theme }) => theme.glass_border};

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 4px;
    height: 100%;
    background: ${({ theme }) => theme.gradient_primary};
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &:hover {
    box-shadow: 0 20px 40px ${({ theme }) => theme.shadow_primary};
    transform: translateY(-5px);
    border-color: ${({ theme }) => theme.primary + '50'};
  }
  
  &:hover::before {
    opacity: 1;
  }

  @media (max-width: 768px) {
    width: 100%;
    padding: 14px 16px;
    gap: 10px;
    border-radius: 12px;
  }

  @media (max-width: 480px) {
    padding: 12px 14px;
  }
`;

const Top = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
`;

const Logo = styled.img`
  height: 50px;
  width: 50px;
  object-fit: contain;
  background-color: ${({ theme }) => theme.bg};
  border-radius: 12px;
  margin-top: 4px;
  padding: 4px;
  border: 1px solid ${({ theme }) => theme.glass_border};

  @media (max-width: 768px) {
    height: 40px;
    width: 40px;
  }
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 2px;
`;

const Name = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => theme.text_primary};
  transition: color 0.3s ease;
  
  ${Card}:hover & {
    color: ${({ theme }) => theme.primary};
  }

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

const Degree = styled.p`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.text_secondary};

  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

const Date = styled.p`
  font-size: 12px;
  font-weight: 400;
  color: ${({ theme }) => theme.text_secondary};
  font-family: 'JetBrains Mono', monospace;

  @media (max-width: 768px) {
    font-size: 10px;
  }
`;

const Description = styled.div`
  width: 100%;
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.text_secondary};
  margin-bottom: 8px;
  line-height: 1.6;

  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

const Span = styled.span`
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  max-width: 100%;
  text-overflow: ellipsis;
`;

const Grade = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme }) => theme.primary};
  background: ${({ theme }) => theme.primary + '15'};
  padding: 6px 12px;
  border-radius: 8px;
  width: fit-content;

  @media (max-width: 768px) {
    font-size: 12px;
    padding: 4px 10px;
  }
`;

const EducationCard = ({ education }) => {
  return (
    <Card>
      <Top>
        <Logo src={education.img} alt={education.school} />
        <Body>
          <Name>{education.school}</Name>
          <Degree>{education.degree}</Degree>
          <Date>{education.date}</Date>
        </Body>
      </Top>
      <Grade>📊 Grade: {education.grade}</Grade>
      <Description>
        <Span>{education.desc}</Span>
      </Description>
    </Card>
  )
}

export default EducationCard;